<script setup lang="ts">
const props = defineProps({
	actions: {
		type: Boolean,
		default: false,
	},
});
</script>

<template>
	<v-card elevation="2">
		<v-card-text>
			<slot />
		</v-card-text>
		<v-card-actions v-if="actions">
			<slot name="actions"></slot>
		</v-card-actions>
	</v-card>
</template>
